import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, TextField, Grid, DialogActions, Typography, CircularProgress, Box } from '@mui/material';
export function AddClienteDialog({ CrmService, onClose, title, ...props }) {
    const [loadCliente, setLoadCliente] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [cliente, setCliente] = useState(null);
    const [error, setError] = useState(null);
    const alreadyExists = async () => {
        setCliente(null);
        try {
            if (Number(inputValue)) {
                let result = await CrmService.checkCliente(Number(inputValue));
                if (!result) {
                    getCliente();
                }
                else {
                    setError('Cliente já existe no SGI.');
                }
            }
            else {
                setError('Por favor, insira um NIF válido.');
            }
        }
        catch (error) {
            console.log('Erro ao verificar se cliente já existe: ', error);
        }
    };
    const getCliente = async () => {
        if (!inputValue.trim()) {
            setError('Por favor, insira um NIF válido.');
            return;
        }
        setError(null);
        setLoadCliente(true);
        try {
            const cli = await CrmService.getPriClienteByNif(Number(inputValue));
            let Pricli = {
                nome: cli[0].nome,
                email: cli[0].cduEmail,
                contacto: cli[0].facTel,
                morada: cli[0].facMor,
                observacoes: cli[0].notas,
                refPriCliente: cli[0].cliente,
                nif: cli[0].numcontrib,
                cae: cli[0].cduCae,
                localidade: cli[0].facCploc,
                condicoesPagamento: cli[0].condpag
            };
            setCliente(Pricli);
        }
        catch (err) {
            setError('Erro ao obter cliente. Verifique o NIF e tente novamente.');
            setCliente(null);
        }
        finally {
            setLoadCliente(false);
        }
    };
    return (<Dialog {...props} fullWidth maxWidth='lg' onClose={() => onClose(null)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={9}>
            <TextField fullWidth id='nif' label='NIF' color='info' size='small' value={inputValue} onChange={e => setInputValue(e.target.value)} error={!!error} helperText={error}/>
          </Grid>

          <Grid item xs={3}>
            <Button fullWidth onClick={alreadyExists} variant='contained' disabled={loadCliente}>
              Procurar Cliente
            </Button>
          </Grid>
        </Grid>

        {/* { && <CircularProgress sx={{ mt: 2 }} />} */}
        {loadCliente ? (<Box sx={{ alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
              A Carregar Cliente:
            </Typography>
            <CircularProgress sx={{ mt: 2 }}/>
          </Box>) : (<></>)}

        {cliente && (<>
            <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
              Dados do Cliente:
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} md={cliente?.nome.length > 45 ? 12 : 5}>
                <Typography variant='body1'>
                  <strong>Nome:</strong> {cliente.nome ?? 'Não tem'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={cliente?.nome.length > 45 ? 12 : 7}>
                <Typography variant='body1'>
                  <strong>Email:</strong> {cliente.email ?? 'Não tem'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={5}>
                <Typography>
                  <strong>Contacto:</strong> {cliente.contacto ?? 'Não tem'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={7}>
                <Typography>
                  <strong>Morada:</strong> {cliente.morada ?? 'Não tem'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={cliente?.observacoes?.length > 60 ? 12 : 5}>
                <Typography>
                  <strong>Ref. Primavera:</strong> {cliente.refPriCliente ?? 'Não tem'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={cliente?.observacoes?.length > 60 ? 12 : 7}>
                <Typography>
                  <strong>Observações:</strong> {cliente.observacoes ?? 'Não tem'}
                </Typography>
              </Grid>
            </Grid>
          </>)}
      </DialogContent>
      <DialogActions sx={{ mt: 1 }}>
        <Button onClick={() => onClose(null)}>Cancelar</Button>
        <Button onClick={() => {
            onClose({
                id: 0,
                uuid: '',
                nome: cliente.nome,
                refClientePrimavera: cliente.refPriCliente,
                nif: cliente.nif,
                email: cliente.email,
                contactoTelefonico: cliente.contacto,
                morada: cliente.morada,
                cae: cliente.cae,
                localidade: cliente.localidade,
                condicoesPagamento: cliente.condicoesPagamento
            });
        }} variant='contained' disabled={cliente === null ? true : false}>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
}
